import { Injectable } from '@angular/core';
import { PaymentCardNames } from '../constants/const';

@Injectable({
  providedIn: 'root',
})
export class MaskService {
  constructor() {}
  maskCardNumberWithoutSpace(cardNumber: string, brand: string): string {
    const dictBrandNoSpaces: { [key: number]: string } = {
      0: `***********${cardNumber}`,
      1: `************${cardNumber}`,
    };
    return dictBrandNoSpaces[
      Number(brand !== PaymentCardNames.american_express)
    ];
  }
  maskCardNumber(cardNumber: string, brand: string): string {
    const dictBrandSpaces: { [key: number]: string } = {
      0: `**** **** *** ${cardNumber}`,
      1: `**** **** **** ${cardNumber}`,
    };
    return dictBrandSpaces[Number(brand !== PaymentCardNames.american_express)];
  }
}
